<template>
    <div class="base-modal" @click.self="close">
        <div
            class="base-modal__content"
            :class="modalTypeClass"
            role="dialog"
            aria-modal="true"
            aria-labelledby="base-modal-title"
        >
            <header class="base-modal__header spacing-b-5">
                <slot name="header" />
                <slot name="close">
                    <button
                        type="button"
                        class="base-modal__close-btn"
                        aria-label="Fechar"
                        @click="close"
                    >
                        &#10005;
                    </button>
                </slot>
            </header>

            <section class="base-modal__body spacing-b-6">
                <slot />
            </section>

            <footer class="base-modal__footer">
                <slot name="footer" />
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
		props: {
			modalType: {
				type: String,
				default: ''
			}
		},
		computed: {
			modalTypeClass() {
				return this.modalType === 'timeout' ? 'base-modal__content--large' : '';
			}
		},
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>

<style scoped lang="scss">
    .base-modal {
        position: fixed;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 50;

        &__content {
            background: white;
            border-radius: 24px;
            max-width: 328px;
            width: 90%;
            padding: 24px;
        }

		&__content--large {
			max-width: 584px;
		}

        &__header {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

        &__footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

		&__content--large .base-modal__footer {
			justify-content: flex-end;
			gap: 16px;
		}

		&__close-btn {
			background: none;
			border: none;
			font-size: 20px;
			color: #2F363E;
		}

        &__btn {
            padding: 10px 29px;
            font-weight: 600;
            border: none;
            border-radius: 24px;
            cursor: pointer;
            transition: background 0.2s;
            min-width: 132px;

            &:hover, &:focus {
                outline: 2px solid #1976d2;
            }

            &--full-width {
                width: 100%;
            }

            &--primary {
                background-color: #0774E7;
                color: white;

                &:hover, &:focus {
                    background-color: #005bb5;
                }
            }

            &--secondary {
                background-color: transparent;
                border: 1.5px solid #0774E7;
                color: #0774E7;

                &:hover, &:focus {
                    background-color: #E6F0FA;
                }
            }

            &--danger {
                background-color: #DC392A;
                color: white;

                &:hover, &:focus {
                    background-color: #d32f2f;
                }
            }

            &--gray {
                background-color: #EFF1F3;
                color: #000000;

                &:hover, &:focus {
                    background-color: #e0e0e0;
                }
            }
        }
    }

</style>
